import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { api } from '../utils/api';

export const ProtectedRoute = ({ children }) => {
  const isAuthenticated = api.isAuthenticated();
  
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};
